import { keyframes } from "@mui/system";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// 깜빡이는 애니메이션
const blinkAnimation = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

function RotatingCardFront({ color, image, icon, title, description }) {
  return (
    <MKBox
      display="flex"
      justifyContent="center"
      alignContent="center"
      borderRadius="lg"
      coloredShadow={color}
      width={{ xs: "90%", sm: "95%", md: "100%" }} // 반응형 너비
      height={{ xs: "250px", sm: "350px", md: "500px" }} // 반응형 높이
      position="relative"
      zIndex={2}
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba } }) =>
          `${linearGradient(
            rgba("rgb(104, 52, 155)", 0.85),
            rgba("rgb(104, 52, 155)", 0.85)
          )}, url(${image})`,
        backgroundSize: "cover",
        backfaceVisibility: "hidden",
      }}
    >
      <MKBox
        py={{ xs: 4, sm: 6, md: 12 }}
        px={{ xs: 2, sm: 3, md: 4 }}
        textAlign="center"
        lineHeight={1}
      >
        {icon && (
          <MKTypography
            variant="h2"
            color="white"
            my={2}
            sx={{
              fontSize: { xs: "3rem", sm: "5rem", md: "7rem" }, // 반응형 아이콘 크기
              animation: `${blinkAnimation} 1.5s infinite`,
            }}
          >
            {typeof icon === "string" ? <Icon>{icon}</Icon> : icon}
          </MKTypography>
        )}
        <MKTypography
          variant="h3"
          color="white"
          gutterBottom
          sx={{ fontSize: { xs: "1.25rem", sm: "1.75rem", md: "2.5rem" } }} // 반응형 제목 크기
        >
          {title}
        </MKTypography>
        <MKTypography
          variant="body2"
          color="white"
          opacity={0.8}
          sx={{ fontSize: { xs: "0.65rem", sm: "0.85rem", md: "1rem" } }} // 반응형 설명 크기
        >
          {description}
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}

RotatingCardFront.defaultProps = {
  color: "info",
  icon: "",
};

RotatingCardFront.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  image: PropTypes.string.isRequired,
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
};

export default RotatingCardFront;
